import IconNotification from '@shared/icons/IconNotification';
import Breadcrumbs from '@widgets/breadcrumbs';
import Search from '@widgets/components/search';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useReportLastSyncDate } from '@app/queries/main/useReportLastSyncDate';
import { useSelector } from 'react-redux';
import { selectSidebar } from '@app/redux/features/sidebarSlice';
import IconReport from '@shared/icons/IconReport';
import { getBase64 } from '@app/utils/baseEncoder';
import { toast } from 'react-toastify';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';
import { useUploadReport } from '@app/queries/application/useUploadReport';
import { GrayButton } from '@shared/uikit/button';
import { selectLastUploadedReportAt } from '@app/redux/features/userSlice';

const Header = () => {
  const [search, setSearch] = useState('');

  const showSidebar = useSelector(selectSidebar);
  const reportLastSyncDate = useSelector(selectLastUploadedReportAt);
  const uploadReportFetcher = useUploadReport();

  const fileInput = useRef<HTMLInputElement>(null);

  /*
    const onClickUpload = useCallback(() => {
        fileInput?.current?.click();
    }, []);

    const clearChosenFile = () => {
        if (fileInput.current) {
            fileInput.current.value = '';
        }
    };


    const onUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target?.files) return;

        const file = e.target?.files[0];

        (async () => {
            try {
                const data = await getBase64(file);
                await uploadReportFetcher.fetchData({
                    data: '' + data,
                    title: file.name,
                });
                toast.success('Отчет успешно загружен');
                clearChosenFile();
            } catch (e: any) {
                clearChosenFile();
                if (e.status === ERR_BAD_REQUEST) {
                    toast.error(e.response.data.error);
                } else {
                    toast.error('Ошибка загрузки');
                }
            }
        })();
    };
    */

  return (
    <div
      className={`bg-[#141316] absolute top-[0] ${showSidebar ? 'w-[calc(100%-240px)]' : 'w-[calc(100%-118px)]'} pb-[30px] pt-[36px] z-[40] `}
    >
      <div className={`flex justify-between items-center`}>
        <Breadcrumbs />
        <div className="flex gap-[20px] items-center pr-[20px]">
          {/*<Search search={search} onSearch={setSearch} />*/}

          {/*<div>*/}
          {/*    <input type='file' className='hidden' ref={fileInput} onChange={onUpload} />*/}
          {/*    <GrayButton*/}
          {/*        onClick={() => onClickUpload()}*/}
          {/*        title={*/}
          {/*            <div className='flex gap-[5px] items-center fill-[white] text-[18px] cursor-pointer'>*/}
          {/*                +*/}
          {/*            </div>*/}
          {/*        }*/}
          {/*    />*/}
          {/*</div>*/}

          <span>{reportLastSyncDate ? reportLastSyncDate : 'Loading...'}</span>
          <IconNotification />
        </div>
      </div>
    </div>
  );
};

export default Header;
